<mat-tab-group *ngIf="(store$ | async) as store" color="accent" class="ns-mat-tab-group" (selectedTabChange)="updateIndex($event)">
  <mat-tab label="Graph">
    <ng-template matTabContent>
      <div class="d-flex flex-column" style="height: 70vh;">
        <ng-container *ngIf="!store.state.loading; else mask">
          <div echarts [options]="chartConfig" class="flex-fill"></div>
          <div class="m-3">
            <p class="p-0">*Metrics are historical data and are loaded every 12 hours, delayed reporting may not be reflected on the screen.</p>
          </div>
        </ng-container>
        <ng-template #mask>
          <ns-skeleton class="flex-fill" [type]="skeleton"></ns-skeleton>
        </ng-template>
      </div>
    </ng-template>
  </mat-tab>
  <mat-tab label="Grid">
    <ng-template matTabContent>
      <ns-grid
        style="height: 70vh;"
        name="ECR_METRICS"
        gridTitle="Fill Metrics"
        fileName="fill_metrics"
        [columns]="columns"
        [gridOptions]="gridOptions"
        [config]="gridConfig"
        [data]="store.state.grid"
        [loading]="store.state.loading"
        (refresh)="dispatchAction()">
      </ns-grid>
    </ng-template>
  </mat-tab>
</mat-tab-group>
<div id='ZN_8ALfMrPTqVKySTI'><!--QSI - DO NOT REMOVE-CONTENTS PLACED HERE--></div>
